<template>
    <div class="animated fadeIn">
        <component-header
            title="Offer-Image"
            @search-query="(val) => (filter = val)"
            :isLoading="loading"
            @reload-data="items"
            :hasCreate="false"
        />
        <b-row>
            <b-col>
                <transition name="fade">
                    <b-card border-variant="info">
                        <div>
                            <b-row>
                                <b-col cols md="4">
                                    <b-card>
                                        <h4>Add New Offers Image here</h4>
                                        <label for="">Offer Image:</label>
                                        <b-form-file
                                            placeholder="Choose an Offer Image..."
                                            drop-placeholder="Drop Image here..."
                                        ></b-form-file>
                                        <b-row
                                            class="text-center"
                                            align-v="center"
                                        >
                                            <b-col
                                                ><b-button
                                                    class="mt-3 my -0 main-navigation-button w-50"
                                                    variant="primary"
                                                    @click="onsubmit"
                                                    >Submit</b-button
                                                ></b-col
                                            >
                                        </b-row>
                                    </b-card>
                                </b-col>
                                <b-col cols="8">
                                    <b-collapse id="collapse1" visible>
                                        <div class="mt-3">
                                            <b-table
                                                :dark="dark"
                                                :hover="hover"
                                                :striped="striped"
                                                :bordered="bordered"
                                                :small="small"
                                                :fixed="fixed"
                                                responsive="sm"
                                                id="my-table"
                                                :items="items"
                                                :current-page="currentPage"
                                                :per-page="perPage"
                                                :filter="filter"
                                                thead-class="header"
                                                class="mt-3"
                                                :busy="loading"
                                                show-empty
                                                :fields="imageColumns"
                                                :sort-by.sync="sortBy"
                                                :sort-desc.sync="sortDesc"
                                            >
                                                <template
                                                    slot="name"
                                                    slot-scope="data"
                                                >
                                                    <div class="table-row">
                                                        {{ data.userName }}
                                                    </div>
                                                </template>
                                                <template
                                                    slot="cell(action)"
                                                    slot-scope="data"
                                                >
                                                    <b-button
                                                        size="sm"
                                                        class="mr-2"
                                                        variant="primary"
                                                        @click="
                                                            editTenant(
                                                                data.item,
                                                            )
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-pencil-alt"
                                                        ></i>
                                                    </b-button>
                                                </template>
                                            </b-table>
                                        </div>
                                    </b-collapse>
                                </b-col>
                            </b-row>
                        </div>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cTable from "../base/Table.vue";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "ViewItem",
    components: {
        cTable,
        ComponentHeader,
    },
    data: () => {
        return {
            transProps: {
                name: "flip-list",
            },
            showDismissibleAlert: false,
            loading: false,
            filter: "",
            sortBy: "createdAt",
            sortDesc: true,
            items: [
                {
                    _id: "1",
                    image: "abcd",
                },
                {
                    _id: "2",
                    image: "lmnop",
                },
                {
                    _id: "3",
                    image: "asdf",
                },
            ],
            imageColumns: [
                {
                    key: "_id",
                    sortable: true,
                },
                {
                    key: "image",
                },
                {
                    key: "action",
                },
            ],
            fields: [],
            filter: "",
            caption: "Table",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            tableData: [],
            currentPage: 1,
            perPage: 7,
            dark: false,
        };
    },
    methods: {
        onsubmit() {
            this.$swal({
                title: "Success",
                text: "image added successfully!!",
                type: "success",
            });
        },
    },
};
</script>

<style scoped></style>
